/* --------------------------------------
   Elements animation
----------------------------------------- */

const elementsAnimations = {
  config: {
    animationClass: 'animation-in',
    firstAnimationTimeout: 200,
  },


  // adds each word of the phrase in a temp container
  splitText: function(el) {
    const content = el.innerHTML;
    const words = content.split(' ');
    var out = '';
    //Replaced foreach to Array.prototype.forEach for IE11
    Array.prototype.forEach.call(words, function(word,index) {
      out += '<span class="temp">' + word + '</span> ';
    })
    el.innerHTML = out;
  },


  // creates an array with each line comparing the temp containers offset
  createRows: function(el) {
    const temps = el.querySelectorAll('.temp');
    const rows = [];
    var offset = 0;

    //Replaced foreach to Array.prototype.forEach for IE11
    Array.prototype.forEach.call(temps, function(temp, index) {
      const currTemp = temp.offsetTop;

      if (currTemp > offset) {
        rows[currTemp] = temp.innerHTML;
        offset = currTemp;

      } else if (currTemp == offset) {
        rows[currTemp] = rows[currTemp] + ' ' + temp.innerHTML;
      }
    });
    return rows;
  },


  // adds the animations attributes for each row
  addAnimationsAtts: function(rows, el) {
    const animationName = el.getAttribute('data-animation-name');
    const animationDelayStart = parseInt(el.getAttribute('data-animation-delay'));
    const animationDelayPace = parseInt(el.getAttribute('data-animation-pace'));
    var out = '';
    var nr = 0;

    //Replaced foreach to Array.prototype.forEach for IE11
    Array.prototype.forEach.call(rows,function(row) {
      const animationDelay = animationDelayStart + animationDelayPace * nr;
      out += '<span data-animation="' + animationName + '" data-delay="' + animationDelay + '">' + row + '</span>';
      nr++;
    });

    el.innerHTML = out;
  },


  // creates rows containers for a text
  parseRowsAnimations: function() {
    const rowsAnimations = document.querySelectorAll('[data-animation-type="rows"]');

    //Replaced foreach to Array.prototype.forEach for IE11

    Array.prototype.forEach.call(rowsAnimations, function(el) {

      // --- adds each word of the phrase in a temp container
      elementsAnimations.splitText(el);

      // --- creates an array with each line comparing the temp containers offset
      const rows = elementsAnimations.createRows(el);

      // --- adds the animations attributes for each row
      elementsAnimations.addAnimationsAtts(rows, el);

    });
  },


  // adds initial animation class
  addInitalClass: function() {
    const slide = document.querySelectorAll('[data-slide="1"]');
    if (slide.length > 0) {
      setTimeout(function () {
        slide[0].classList.add(elementsAnimations.config.animationClass)
      }, elementsAnimations.config.firstAnimationTimeout);
    }
  },


  // initializes the animations
  init: function(disable) {
    if (disable) {
      return false;
    }

    elementsAnimations.parseRowsAnimations();
    elementsAnimations.addInitalClass();
  }

};

const section = document.body.classList;
const screenWidth = window.innerWidth;
//Check if Mobile Device
const isMobileDevice = function() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};
const disable = ( ( isMobileDevice && screenWidth < 768 ) || typeof(section) == 'undefined' || !section.contains('path-frontpage') ) ? true : false;

elementsAnimations.init(disable);
